// 카카오 JS SDK 앱 키 — 환경(hostname)별 선택 (2026-05-28)
//   카카오 콘솔의 JS 키마다 "JS SDK 도메인" 허용목록이 따로다. 도메인 ≠ 등록키 시 Error 4019.
//   - 운영(autodex.kr 등): 'autodex' 키 (16d4abc8...) — autodex.kr 등록됨
//   - 테스트(test.autodex.kr)/로컬: '오토덱스 테스트vm' 키 (90bfc6ea...) — test.autodex.kr 등록 전제
//   ⚠️ 각 키에 해당 도메인이 카카오 콘솔 [플랫폼>Web / JS SDK 도메인]에 등록돼 있어야 동작.
// CommonJS — 루트 jest 단위 테스트 + CRA(webpack) import 양쪽 호환.

var KAKAO_KEY_PROD = '16d4abc8bd86cf23c6e2e1a54f55f13b'; // autodex 키 (운영 autodex.kr)
var KAKAO_KEY_TEST = '90bfc6ea237b108d1f787f072b85eadc'; // 오토덱스 테스트vm 키 (test.autodex.kr/로컬)

// hostname → 카카오 JS 키. test.* / localhost / 127.0.0.1 → 테스트 키, 그 외 → 운영 키(무회귀).
function getKakaoAppKey(hostname) {
  var host = hostname || '';
  if (host.indexOf('test.') === 0 || host === 'localhost' || host === '127.0.0.1') {
    return KAKAO_KEY_TEST;
  }
  return KAKAO_KEY_PROD;
}

module.exports = {
  getKakaoAppKey: getKakaoAppKey,
  KAKAO_KEY_PROD: KAKAO_KEY_PROD,
  KAKAO_KEY_TEST: KAKAO_KEY_TEST
};
